/* eslint-disable */

/*
* Tooltip have some options
* This tooltip can be used anywhere and is exposed in the whole app
*
* @param data : String => Value to show
* @param arrowPosition : String (default : 'bottom') => Position of arrow (which places the tooltip)
* @param isDisabled : Boolean (default : 'true') => show tooltip depend of this parameter
*
* For example :
*
*  <span v-tooltip="{
*       data: 'data to showed'
*       arrowPosition: 'top' // available values (bottom|top|left|right)
*       isDisabled: true
*   }"> some text
*  </span>
*
* */

import Vue from 'vue'

const CONFIG = {
    spacingTop: 40,
    spacingBottom: 20,
    spacingLeft: 8,
    prefix: 'v-tooltip'
};

const handleMouseEnter = (el, binding) => {
    const vTooltip = document.createElement('div');
    vTooltip.appendChild(document.createElement('span'));
    const rootElement = el.getBoundingClientRect();
    const { data, arrowPosition = 'bottom', isDisabled = false } = binding.value;


    const whichPosition = () => {
        switch (arrowPosition) {
            case "bottom":
                return `${CONFIG.prefix}__bottom`;
            case "top":
                return `${CONFIG.prefix}__top`;
            case "right":
                return `${CONFIG.prefix}__right`;
            case "left":
                return `${CONFIG.prefix}__left`
        }
    };

    const computePosition = () => {
        switch (arrowPosition) {
            case "bottom":
                vTooltip.style.left = `${rootElement.left + (rootElement.width / 2) - (vTooltip.getBoundingClientRect().width / 2) }px`;
                vTooltip.style.top = `${rootElement.top - rootElement.height - CONFIG.spacingTop}px`;
                break;
            case "top":
                vTooltip.style.left = `${rootElement.left + (rootElement.width / 2) - (vTooltip.getBoundingClientRect().width / 2)}px`;
                vTooltip.style.top = `${rootElement.top + rootElement.height + CONFIG.spacingBottom}px`;
                break;
            case "right":
                vTooltip.style.left = `${rootElement.left - vTooltip.offsetWidth -  CONFIG.spacingLeft}px`;
                vTooltip.style.top = `${rootElement.top - (vTooltip.getBoundingClientRect().height / 2) + (rootElement.height / 2)}px`;
                break;
            case "left":
                vTooltip.style.left = `${rootElement.left + rootElement.width + CONFIG.spacingLeft}px`;
                vTooltip.style.top = `${rootElement.top - (vTooltip.getBoundingClientRect().height / 2) + (rootElement.height / 2)}px`;
        }
    };

    vTooltip.setAttribute('class', `${CONFIG.prefix} ${whichPosition()}`);
    vTooltip.setAttribute('id', 'vTooltip');
    vTooltip.children[0].innerHTML = data;
    document.body.appendChild(vTooltip);
    computePosition()
};

const handleMouseLeave = () => {
    const elemToRemove = document.querySelector('.v-tooltip');
    elemToRemove && elemToRemove.parentNode.removeChild(elemToRemove)
};

Vue.directive('tooltip', {
    bind: function (el, binding) {
        if(binding.value.isDisabled) return;
        el.addEventListener('mouseenter', () =>  handleMouseEnter(el, binding));
        el.addEventListener('click', handleMouseLeave);
        el.addEventListener('mouseleave', handleMouseLeave)
    },
    unbind: function (el, binding) {
        el.removeEventListener('mouseenter', handleMouseEnter);
        el.removeEventListener('click', handleMouseLeave);
        el.removeEventListener('mouseleave', handleMouseLeave);
        const elemToRemove = document.querySelector('.v-tooltip');
        elemToRemove && elemToRemove.parentNode.removeChild(elemToRemove)
    }
});
